export const ASSIGNED_ACCOUNTS_SYSTEM_REFERENCE = 'Assigned Accounts';
export const TERRITORY_BOTTOMS_UP_SYSTEM_REFERENCE = 'Territories';

export const TERRITORY_WORKSHEET_PARENT_COLUMN_NAME = 'Territory Parent';
export const TERRITORY_ID_COLUMN_NAME = 'Territory ID';
export const TERRITORY_WORKSHEET_NAME_FIELD = 'Territory Name';
export const TERRITORY_WORKSHEET_UNIQUE_COLUMN_NAME = 'Territory ID';
export const DATA_OBJECT_TERRITORY = 'territory';
export const DATA_OBJECT_TERRITORY_OWNER = 'Territory Owner';

export const PICKLIST_EMPLOYEE_MAGIC_ATTRIBUTE_ID = 'ID';
export const PICKLIST_EMPLOYEE_MAGIC_ATTRIBUTE_FIRST_NAME = 'First Name';
export const PICKLIST_EMPLOYEE_MAGIC_ATTRIBUTE_LAST_NAME = 'Last Name';
export const PICKLIST_EMPLOYEE_MAGIC_ATTRIBUTE_EMAIL = 'Email';

export const TERRITORY_DESTINATION_WORKSHEET_NAME = 'Territories';
export const ACCOUNT_DESTINATION_WORKSHEET_NAME = 'Accounts';

export const TERRITORY_ASSIGNMENT_OVERRIDE_COLUMN_NAME = 'Territory Assignment Override';

export const PICKLIST_EMPLOYEE_MAGIC_ATTRIBUTES = [
  PICKLIST_EMPLOYEE_MAGIC_ATTRIBUTE_ID,
  PICKLIST_EMPLOYEE_MAGIC_ATTRIBUTE_FIRST_NAME,
  PICKLIST_EMPLOYEE_MAGIC_ATTRIBUTE_LAST_NAME,
  PICKLIST_EMPLOYEE_MAGIC_ATTRIBUTE_EMAIL,
];

export const EDITABLE_SYSTEM_COLUMNS = [DATA_OBJECT_TERRITORY_OWNER];

export const METRIC_AXIS_TYPE_DATA_FIELD = 'data_field';
export const METRIC_AXIS_TYPE_ACCOUNTS = 'accounts';

export const ERROR_PREFIXES = ['value_error||', 'na_error||', 'reference_error||', 'divide_by_zero_error||'];

export const SPM_PLANNING_CYCLE_SCENARIO_WORKSHEET_NAME = 'Plan Metrics';
